import React from "react";
import ProjectsTabsSection from "../components/ProjectsTabsSection";

export default function About() {
    return (
        <>
            <section className="pt-5 pb-4" style={{ paddingTop: "50px", paddingBottom: "40px" }}>
                <div className="container">
                    <div className="row align-items-center g-5">

                        {/* Left Side */}
                        <div className="col-md-6">
                            <h1 className="fw-bold display-5">
                                Building intelligence into your business
                            </h1>
                        </div>

                        {/* Right Side */}
                        <div className="col-md-6">
                            <div className="animated-gradient-box">
                                <div className="animated-gradient-content p-4 text-center">

                                    <p className="mb-3 fs-5 text-dark">
                                        We build innovative digital solutions that empower businesses
                                        to grow and scale globally.
                                    </p>

                                    <button className="btn btn-dark fw-semibold px-4">
                                        Learn More
                                    </button>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <ProjectsTabsSection />

            <section style={{ paddingTop: 50, paddingBottom: 40 }}>
                <div className="container">
                    <div className="row align-items-center">

                        {/* Left Side - Heading */}
                        <div className="col-md-6">
                            <h2 className="fw-bold mb-0">
                                AI-native solutions for modern businesses
                            </h2>
                        </div>

                        {/* Right Side - Paragraph */}
                        <div className="col-md-6">
                            <p className="text-secondary mb-0" style={{ lineHeight: 1.8 }}>
                                OSLO Labs is an AI-native technology company that designs, builds, and ships intelligent systems for businesses ready to move faster. We combine deep technical expertise with product thinking to deliver working solutions, not presentations.
                            </p>
                        </div>

                    </div>
                </div>
            </section>

            <section style={{ paddingTop: 50, paddingBottom: 40 }}>
                <div className="container">

                    {/* Section Heading */}
                    <div className="mb-5">
                        <h2 className="fw-bold mb-0">Agents that do the boring parts</h2>
                    </div>

                    {/* 2x2 Grid */}
                    <div className="row g-4">

                        {/* Card 1 */}
                        <div className="col-12 col-md-6">
                            <div
                                className="service-card p-4 p-md-5 d-flex flex-column justify-content-end"
                                style={{
                                    borderRadius: 14,
                                    height: 360,
                                    background:
                                        "radial-gradient(77.26% 79.3% at 83.45% 22.74%, #FF9807 0%, #FF7D71 22.62%, #FFE761 61.06%, #FFFFFF 100%)",
                                }}
                            >
                                <p className="mb-3 text-dark" style={{ lineHeight: 1.7, maxWidth: 520 }}>
                                    Build bespoke AI systems tailored to your business logic. From intelligent
                                    workflows to decision automation, we create solutions that understand your
                                    context and drive measurable outcomes.
                                </p>
                                <div className="fw-semibold">
                                    Custom AI Development
                                </div>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="col-12 col-md-6">
                            <div
                                className="service-card p-4 p-md-5 d-flex flex-column justify-content-end"
                                style={{
                                    borderRadius: 14,
                                    height: 360,
                                    background:
                                        "radial-gradient(70% 80% at 30% 25%, #FFB34D 0%, #FFE761 45%, #FFFFFF 100%)",
                                }}
                            >
                                <p className="mb-3 text-dark" style={{ lineHeight: 1.7, maxWidth: 520 }}>
                                    Deploy autonomous agents that handle repetitive work across sales,
                                    support, operations, and marketing. Your team focuses on strategy
                                    while AI handles execution at scale.
                                </p>
                                <div className="fw-semibold">
                                    AI Agents & Automation
                                </div>
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="col-12 col-md-6">
                            <div
                                className="service-card p-4 p-md-5 d-flex flex-column justify-content-end"
                                style={{
                                    borderRadius: 14,
                                    height: 360,
                                    background:
                                        "radial-gradient(70% 80% at 25% 20%, #FF7D71 0%, #FFE761 55%, #FFFFFF 100%)",
                                }}
                            >
                                <p className="mb-3 text-dark" style={{ lineHeight: 1.7, maxWidth: 520 }}>
                                    Connect AI capabilities to your existing tech stack. We architect
                                    scalable systems that work with your tools, data, and workflows
                                    without disruption.
                                </p>
                                <div className="fw-semibold">
                                    AI Integration & Infrastructure
                                </div>
                            </div>
                        </div>

                        {/* Card 4 */}
                        <div className="col-12 col-md-6">
                            <div
                                className="service-card p-4 p-md-5 d-flex flex-column justify-content-end"
                                style={{
                                    borderRadius: 14,
                                    height: 360,
                                    background:
                                        "radial-gradient(70% 80% at 35% 25%, #B07CFF 0%, #FF7D71 30%, #FFE761 60%, #FFFFFF 100%)",
                                }}
                            >
                                <p className="mb-3 text-dark" style={{ lineHeight: 1.7, maxWidth: 520 }}>
                                    Ship AI-powered products that users love. We design and develop
                                    consumer and B2B applications with intelligence built into the
                                    core experience.
                                </p>
                                <div className="fw-semibold">
                                    Intelligent Products
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
}